import Link from "next/link";
import { CloseIcon } from "@/components/Icons";
import { useEffect } from "react";
import { useTrackingAnalytics } from "@/hooks/useTrackingAnalytics";
import { isTvEnv, uniqueAppRedirectionDeeplink } from "@/utils/common.helpers";
import { useRouter } from "next/navigation";
import { Img } from "@/components/Img";
import { useClientTranslations } from "@/hooks/useClientTranslations";

export const AppDownloadPopup = ({
  toggleDownloadPopup,
  initialState,
  sourcePage,
}: {
  toggleDownloadPopup: Function;
  initialState: boolean;
  sourcePage: string;
}) => {
  const { trackEvent } = useTrackingAnalytics();
  const { t } = useClientTranslations();
  const router = useRouter();

  useEffect(() => {
    if (initialState) {
      trackEvent({
        eventName: "campaign_card_viewed",
        properties: {
          campaign_type: "download_popup",
          page_name: sourcePage,
        },
        sendTo: [],
      });
    }
  }, [initialState, sourcePage, trackEvent]);

  return (
    <>
      {initialState ? (
        <div
          className="center-fixed fixed z-10 flex h-full w-full items-center justify-center"
          data-testid="app-download-popup"
        >
          <div className="app-download-popup-bg fixed z-20 h-full w-full opacity-50" />
          <div
            className={`app-download-popup-container justicy-center relative z-30 mx-10 aspect-[163/195] ${isTvEnv() ? "h-[43rem] w-[35rem]" : "w-full"} rounded-2xl border border-solid px-6 py-4 md:w-[25%] xl:w-[30%]`}
          >
            <div
              onClick={() => {
                trackEvent({
                  eventName: "campaign_card_clicked",
                  properties: {
                    campaign_type: "download_popup",
                    page_name: sourcePage,
                    cta: "close_icon",
                  },
                  sendTo: [],
                });
                toggleDownloadPopup(false);
              }}
              className="absolute right-4 z-40 p-4"
              data-testid="download-popup-close-btn"
            >
              <CloseIcon />
            </div>
            <Link
              href={uniqueAppRedirectionDeeplink()}
              rel="nofollow"
              onClick={(e) => {
                e.preventDefault();
                trackEvent({
                  eventName: "campaign_card_clicked",
                  properties: {
                    campaign_type: "download_popup",
                    page_name: sourcePage,
                    cta: "download_app",
                  },
                  sendTo: [],
                });
                router.push(uniqueAppRedirectionDeeplink());
              }}
            >
              <Img
                src={
                  process.env.NEXT_PUBLIC_CDN_ROOT_URL +
                  t("content_detail.app_download_popup")
                }
                fill={true}
                alt="App download popup"
              />
            </Link>
          </div>
        </div>
      ) : null}
    </>
  );
};
